var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.1278,
    cy: 26,
    r: 21.1278,
    fill: "#DFEAEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_220_3111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5282 24.3199C37.5282 27.3266 35.0947 29.7641 32.0929 29.7641H10.0105C7.0087 29.7641 4.5752 27.3266 4.5752 24.3199C4.5752 21.941 6.09863 19.92 8.22191 19.1793C8.04749 16.5039 10.1656 14.2805 12.798 14.2805C13.5073 14.2805 14.1786 14.4423 14.7778 14.7298C15.8333 12.3072 18.2449 10.6143 21.0517 10.6143C23.8585 10.6143 26.2701 12.3072 27.3257 14.7298C27.9249 14.4423 28.5962 14.2805 29.3054 14.2805C31.9436 14.2805 34.0559 16.5097 33.8822 19.1793C36.0048 19.92 37.5282 21.941 37.5282 24.3199Z",
    fill: "#A8EBFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5263 24.3199C37.5263 27.3266 35.0928 29.7641 32.091 29.7641H21.0498V10.6143C23.8566 10.6143 26.2682 12.3072 27.3238 14.7298C27.923 14.4423 28.5942 14.2805 29.3035 14.2805C31.9417 14.2805 34.054 16.5097 33.8802 19.1793C36.0029 19.92 37.5263 21.941 37.5263 24.3199Z",
    fill: "#7DD5F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7998 22.5547H32.4183V39.7537H9.7998V22.5547Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0303 22.5547H32.4164V39.7537H21.0303V22.5547Z",
    fill: "#DFE7F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4716 21.8018H9.59628C9.06337 21.8018 8.63086 22.235 8.63086 22.7688V39.4301C8.63086 39.9639 9.06337 40.3971 9.59628 40.3971H32.4716C33.0045 40.3971 33.437 39.9639 33.437 39.4301V22.7688C33.437 22.235 33.0045 21.8018 32.4716 21.8018ZM31.5062 38.4631H10.5617V23.7358H31.5062V38.4631Z",
    fill: "#453D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4487 32.9175C24.0728 33.294 23.4605 33.2956 23.083 32.9175C22.5365 32.3695 21.8086 32.0678 21.035 32.0678C20.2614 32.0678 19.5334 32.3695 18.987 32.9175C18.6098 33.2952 17.9984 33.2952 17.6213 32.9175C17.2447 32.5397 17.2447 31.9272 17.6213 31.5501C18.5333 30.6366 19.7452 30.1338 21.035 30.1338C22.3248 30.1338 23.5367 30.6366 24.4487 31.5501C24.8252 31.9272 24.8252 32.5397 24.4487 32.9175Z",
    fill: "#DF5CCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1811 30.1826C26.8067 30.559 26.1937 30.561 25.816 30.1826C24.5404 28.9036 22.8431 28.1996 21.0378 28.1996C19.2325 28.1996 17.5353 28.9036 16.2596 30.1826C15.8825 30.5597 15.271 30.5604 14.8945 30.1826C14.5174 29.8055 14.5167 29.1931 14.8939 28.8153C16.5344 27.1714 18.7163 26.2656 21.0378 26.2656C23.3593 26.2656 25.5412 27.1714 27.1817 28.8153C27.5589 29.1931 27.5583 29.8055 27.1811 30.1826Z",
    fill: "#DF5CCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0367 35.936C21.5699 35.936 22.0021 35.503 22.0021 34.969C22.0021 34.4349 21.5699 34.002 21.0367 34.002C20.5035 34.002 20.0713 34.4349 20.0713 34.969C20.0713 35.503 20.5035 35.936 21.0367 35.936Z",
    fill: "#DF5CCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0006 34.969C22.0006 35.5027 21.5681 35.936 21.0352 35.936V34.002C21.5681 34.002 22.0006 34.4345 22.0006 34.969Z",
    fill: "#C63EBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4489 31.5501C24.8254 31.9272 24.8254 32.5397 24.4489 32.9175C24.0729 33.294 23.4607 33.2956 23.0831 32.9175C22.5367 32.3695 21.8088 32.0678 21.0352 32.0678V30.1338C22.325 30.1338 23.5369 30.6366 24.4489 31.5501Z",
    fill: "#C63EBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1784 30.1826C26.804 30.559 26.1911 30.561 25.8133 30.1826C24.5377 28.9036 22.8405 28.1996 21.0352 28.1996V26.2656C23.3567 26.2656 25.5385 27.1714 27.1791 28.8153C27.5563 29.1931 27.5556 29.8055 27.1784 30.1826Z",
    fill: "#C63EBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4342 22.7697V39.4311C33.4342 39.9649 33.0017 40.3981 32.4688 40.3981H21.0498V38.4641H31.5034V23.7367H21.0498V21.8027H32.4688C33.0017 21.8027 33.4342 22.2359 33.4342 22.7697Z",
    fill: "#332E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5933 39.4309V39.9163C35.5933 41.9592 33.9341 43.6212 31.8944 43.6212H10.2008C8.16119 43.6212 6.50195 41.9592 6.50195 39.9163V39.4309C6.50195 38.8971 6.93446 38.4639 7.46737 38.4639H34.6279C35.1608 38.4639 35.5933 38.8971 35.5933 39.4309Z",
    fill: "#5E54AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5946 39.4309V39.9163C35.5946 41.9592 33.9354 43.6212 31.8958 43.6212H21.0303V38.4639H34.6292C35.1621 38.4639 35.5946 38.8971 35.5946 39.4309Z",
    fill: "#453D81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_3111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.953,
    height: 33.0069,
    fill: "white",
    transform: "translate(4.57617 10.6143)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon1);
export default __webpack_public_path__ + "static/media/list-icon1.7b7abf2e4d551cf2cd51e24b8cb9a245.svg";
export { ForwardRef as ReactComponent };